<template>
  <a href="#" class="back_btn" @click.prevent="handleGoBack">
    <i class="fas fa-chevron-left"></i>
  </a>
</template>

<script setup>
import usePageNavigationHook from '@/hooks/usePageNavigation.js';

const props = defineProps({
  routeName: {
    type: String,
    default: '',
  },
});

const { indexRouteName, hasBackRoute, redirectBack, redirectTo } = usePageNavigationHook();

const handleGoBack = () => {
  if (hasBackRoute.value) {
    redirectBack();
  } else {
    redirectTo(props.routeName || indexRouteName.value);
  }
};
</script>
